import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=805f5308&scoped=true&"
import script from "./InfoCard.vue?vue&type=script&lang=ts&"
export * from "./InfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=805f5308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805f5308",
  null
  
)

export default component.exports